import React, { useMemo } from 'react';
import GroupElement from './elements/group/GroupElement';
import { getByID } from '../../utils/core';
import Outcome from './Outcome';
import MapElement from './elements/map/MapElement';
import DragElement from './elements/DragElement';
import { Link as LinkIcon } from 'phosphor-react';

export const MemoizedSVGContent = ({
    flowId,
    editingToken,
    mapElementIdFlowId = {},
    groupElementIdFlowId = {},
    mapElements,
    groupSelectedElements,
    selectedElementIds,
    openConfig,
    getKeysWhere,
    sidebarDragElementVisible,
    sidebarDragElementProps,
    newGroup,
    makeGroupIcon,
}) => {

    const mapElementIds = useMemo(() => getKeysWhere((key, val) => val === flowId, mapElementIdFlowId), [mapElementIdFlowId]);
    const groupElementIds = useMemo(() => getKeysWhere((key, val) => val === flowId, groupElementIdFlowId), [groupElementIdFlowId]);

    let selectionBoundary = null;

    if (selectedElementIds.length > 1) {
        selectionBoundary = [
            <rect
                stroke="gray"
                strokeDasharray={2}
                fillOpacity={0}
                {...newGroup}
            />,
            <foreignObject {...makeGroupIcon}>
                <span className="group-element-icon-background" />
                <LinkIcon
                    onClick={() => groupSelectedElements({ flowId, editingToken, ...newGroup })}
                    className="group-element-icon"
                    weight="bold"
                    style={{
                        top: '-1px',
                        fontSize: '12px',
                        position: 'absolute',
                        background: '#f5f5f5',
                    }}
                />
            </foreignObject>,
        ];
    }

    return (
        <>
            {selectionBoundary}
            {
                useMemo(() => mapElementIds.map((mapElementId) => {
                    const mapElement = getByID(mapElementId, mapElements);
                    return mapElement && Array.isArray(mapElement.outcomes) ?
                        mapElement.outcomes.map(outcome => (
                            <Outcome
                                key={outcome.id}
                                mapElement={mapElement}
                                outcome={outcome}
                            />
                        )) :
                        null;
                }), [mapElementIds, mapElements])
            }
            {
                useMemo(() => groupElementIds.map(groupElementId => (
                    <GroupElement 
                        key={groupElementId}
                        groupElementId={groupElementId}
                        openConfig={openConfig}
                        flowId={flowId}
                        editingToken={editingToken}
                    />
                )), [groupElementIds])
            }
            {
                useMemo(() => mapElementIds.map(mapElementId => (
                    <MapElement 
                        key={mapElementId}
                        mapElementId={mapElementId}
                        openConfig={openConfig}
                        flowId={flowId}
                        editingToken={editingToken}
                    />
                )), [mapElementIds])
            }
            {
                useMemo(() => sidebarDragElementVisible ? 
                    <DragElement {...sidebarDragElementProps} /> :
                    null,
                [sidebarDragElementVisible, sidebarDragElementProps])
            }
        </>
    );
};

export default MemoizedSVGContent;
